<!-- 站内信 -->
<template>
  <div class='personal-message'>
    <div class='message'>
      <div class='message-filter'>
        <div class='base-form'>
          <Form ref="formValidate"
                :model="formValidate"
                :rules="ruleValidate"
                :label-width="100">
            <div class='base-item-item'>
              <FormItem label="时间筛选："
                        prop="datetimerange">
                <DatePicker type="datetimerange"
                            placeholder="请选择时间范围"
                            format="yyyy-MM-dd"
                            @on-change="changeTime"></DatePicker>
              </FormItem>
            </div>
            <div class='base-item-item'>
              <a href='javascript:void(0)'
                 class='query'
                 @click='filterMessage'>查询</a>
            </div>
          </Form>
        </div>
        <div class='all-read'>
          <a href='javascript:void(0)'
             @click="hasRead">全部标为已读</a>
        </div>
      </div>
      <ul class='message-list'>
        <li v-for='(item, index) in messageList'
            :key='index'
            @click="detailMessage(item, index)">
          <div :class="[item.isOpen ? 'active' : '', 'message-header', 'clearfix']">
            <span :class="[item.readStatus === 'READ' ? 'read' : 'unread', 'message-header-state']">{{new Map(messageTypeMap).get(item.readStatus)}}</span>
            <span class='message-header-title'>{{item.messageTitle}}</span>
            <span class='message-header-date fr'>{{item.createTime}}</span>
          </div>
          <div class='message-con'
               v-if='item.isOpen'>
            {{item.messageContent}}
          </div>
        </li>
      </ul>
      <div class='page-wrap'>
        <Page :total="page.totalItems"
              :page-size='page.pageSize'
              @on-change='changePage'
              show-total></Page>
      </div>
    </div>
  </div>
</template>

<script>
import { messageTypeMap } from './constants'
import ugdMessageService from '../../../api/message/undergraduate-message'
export default {
  name: '',
  components: {},
  data () {
    return {
      // 消息类型映射
      messageTypeMap,
      // 筛选
      formValidate: {},
      ruleValidate: {},
      // 消息列表
      messageList: [],
      page: {
        pageSize: 10,
        currentPage: 1,
        totalItems: 0
      }
    }
  },
  computed: {},
  mounted () {
    this.filterMessage()
  },
  methods: {
    // 时间筛选-onChange事件
    changeTime (data) {
      this.formValidate.createTimeStart = data[0] + ' 00:00:00'
      this.formValidate.createTimeEnd = data[1] + ' 23:59:59'
    },
    // 查询条件点击
    filterMessage () {
      let query = {
        ...this.formValidate,
        ...this.page
      }
      query.totalItems = 0
      query.currentPage = query.currentPage - 1
      ugdMessageService.page(query).then(res => {
        this.messageList = res.data.page.result
        this.page.totalItems = res.data.page.totalItems
      })
    },
    // 全标为已读
    hasRead () {
      ugdMessageService.readAll().then(res => {
        this.filterMessage()
      })
    },
    // 查看消息详情
    detailMessage (item, index) {
      if (item.readStatus === 'UN_READ') {
        ugdMessageService.read(item.msgId).then(res => {
          this.$set(this.messageList[index], 'readStatus', 'READ')
        }).catch(res => {
          this.$ugd_message(res.message, 'error')
        })
      }
      this.$set(this.messageList[index], 'isOpen', !item.isOpen)
    },
    // 分页切换
    changePage (currentPage) {
      this.page.currentPage = currentPage
      this.filterMessage()
    }
  }
}
</script>
<style lang='less' scoped>
.clearfix {
  *zoom: 1;
  &::after {
    content: "";
    display: block;
    clear: both;
  }
}
.fr {
  float: right;
}
.personal-message {
  padding-top: 40px;
  .message {
    background: #fff;
    padding: 20px 0;
    .message-filter {
      padding: 0 20px;
      display: flex;
      .base-form {
        flex: 1;
        .base-item-item {
          display: inline-block;
          padding-right: 40px;
          .query {
            display: inline-block;
            width: 96px;
            height: 32px;
            background: rgb(224, 235, 254);
            border-radius: 8px;
            border-radius: 8px;
            font-size: 14px;
            color: #186ffa;
            letter-spacing: 0;
            text-align: center;
            line-height: 32px;
            margin-left: 10px;
          }
        }
      }
      .all-read {
        flex: 0 0 120px;
        height: 32px;
        border: 1px solid #b1bcc8;
        border-radius: 3px;
        font-size: 14px;
        letter-spacing: 0;
        text-align: center;
        line-height: 32px;
        a {
          color: #b1bcc8;
        }
      }
    }
    .message-list {
      padding-top: 20px;
      li {
        line-height: 64px;
        border-bottom: 1px solid #f2f2f2;
      }
      li:first-child {
        border-top: 1px solid #f2f2f2;
      }
      .message-header {
        line-height: 64px;
        padding: 0 20px;
        cursor: pointer;
        .message-header-state {
          display: inline-block;
          width: 48px;
          height: 24px;
          opacity: 0.6;

          border-radius: 4px;
          font-size: 14px;

          letter-spacing: 0;
          text-align: center;
          line-height: 24px;
          margin-right: 20px;
          &.read {
            border: 1px solid #9ae6a9;
            color: #9ae6a9;
          }
          &.unread {
            border: 1px solid #ff612f;
            color: #ff612f;
          }
        }
        .message-header-title {
          font-size: 16px;
          color: #323c47;
        }
        .message-header-date {
          font-size: 14px;
          color: #b1bcc8;
        }
        &.active {
          box-shadow: 0 0 16px 0 #e4ebf6;
        }
      }
      .message-con {
        padding: 20px 40px;
        font-size: 14px;
        color: #323c47;
        letter-spacing: 0;
        line-height: 26px;
      }
    }
    .page-wrap {
      padding-top: 40px;
      text-align: center;
    }
  }
}
</style>
